import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";
import { AxDropdown } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";


@ModuleName("ComplexPackageSearchBar")
export class ComplexPackageSearchBar implements AxInit {

    protected datePickerFrom: AxDatePicker;
    protected datePickerTo: AxDatePicker;

    protected datePickerFromMobile: AxDatePicker;
    protected datePickerToMobile: AxDatePicker;

    protected dateFromDropdown: AxDropdown = new AxDropdown();
    protected dateToDropdown: AxDropdown = new AxDropdown();

    dateFrom: moment.Moment;
    dateTo: moment.Moment;

    protected datePattern: string;

    protected allDropDownsSet: boolean = false;

    constructor(private _I18nHelper = new I18nHelper()) { }

    AxInit(initData: ICompPackSearchBarInitData): void {
        $(() => {
            this.datePattern = initData.datePattern;
            this.setUpDatePickerDropDowns(initData);
            this.setupDatePickers(initData);
            this.setupClickListeners();
        });
    }

    // setupClickListeners
    setupClickListeners() {
        // closeOpenSelectors
        window.addEventListener('mouseup', event => {
            const target = event.target as HTMLInputElement;
            this.closeOpenSelectors(target);
        });

        // doSearBarSearch
        $('body').on('click', '#compPacks-teaser-input-search-button', (e) => this.doSearBarSearch());

        // close mobile datePicker
        $('.prod_selection__prod-save').on('click', () => $('.prod_selection__prod-close').trigger('click'));

        // close mobile datePicker
        $('.prod_selection__prod-close').on('click', (x) => {
            this.closeFromDatePickerDesktop();
            this.closeToDatePickerDesktop();
        });
    }

    // setUpDatePickers
    setUpDatePickerDropDowns(initData: ICompPackSearchBarInitData) {
        // from date stuff
        this.dateFromDropdown.init('.compPack-searchbar__from-date-selection .ax-dropdown');
        $('.compPack-searchbar__from-date-selection').on('click', () => {
            this.openFromDatePickerDesktop();
            this.openFromDatePickerMobile();
        });

        // to date stuff
        this.dateToDropdown.init('.compPack-searchbar__to-date-selection .ax-dropdown');
        $('.compPack-searchbar__to-date-selection').on('click', () => {
            this.openToDatePickerDesktop();
            this.openFromDatePickerMobile();
        });
    }

    // setupDatePickers
    setupDatePickers(initData: ICompPackSearchBarInitData) {

        let currentFromDate = null;

        if (initData.toDate && initData.fromDate !== '') {
            currentFromDate = moment(initData.fromDate, "YYYY-MM-DD");
            this.dateFrom = currentFromDate;

            const formattedDate = this.dateFrom.format(this.datePattern);
            this.dateFromDropdown.setValue(formattedDate);
        } else {
            this.dateFromDropdown.resetSelection();
        }

        // from
        this.initDatePickerCompackSearchBar(initData, '#compack-searchBar-from', null, this.datePickerFrom, this.onChangeFromDate,
            this.checkDateFrom, Mode.Inline, this.dateFromDropdown, currentFromDate);

        // mobile from
        this.initDatePickerCompackSearchBar(initData, '#tariff_date_mobile_from', '#tariff_date_mobile__legend_from', this.datePickerFromMobile,
            this.onChangeFromDate, this.checkDateFrom, Mode.Endless, this.dateFromDropdown, currentFromDate);

        let currentToDate = null;

        if (initData.toDate && initData.toDate !== '') {
            currentToDate = moment(initData.toDate, "YYYY-MM-DD");
            this.dateTo = currentToDate;

            const formattedDate = this.dateTo.format(this.datePattern);
            this.dateToDropdown.setValue(formattedDate);
        } else {
            this.dateToDropdown.resetSelection();
        }

        // to
        this.initDatePickerCompackSearchBar(initData, '#compack-searchBar-to', null, this.datePickerTo, this.onChangeToDate,
            this.checkDateTo, Mode.Inline, this.dateToDropdown, currentToDate);

        // mobile to
        this.initDatePickerCompackSearchBar(initData, '#tariff_date_mobile_to', '#tariff_date_mobile__legend_to', this.datePickerToMobile,
            this.onChangeToDate, this.checkDateTo, Mode.Endless, this.dateToDropdown, currentToDate);

        $('.compPack-datePicker-close-btn').click(x => {
            this.closeFromDatePickerMobile();
            this.closeToDatePickerMobile();
        });
    }

    // initDatePickerCompackSearchBar
    initDatePickerCompackSearchBar(initData: ICompPackSearchBarInitData, target: string, legendTarget: string, axDatePicker: AxDatePicker,
        onChange: Function, checkDate: Function, mode: Mode, dropDown: AxDropdown, currentDate: moment.Moment) {

        const endDate = initData.endDate != null ? moment(initData.endDate, "YYYY-MM-DD") : null;

        axDatePicker = new AxDatePicker();

        axDatePicker.Init({
            StartOfWeek: initData.startOfWeek,
            Lang: initData.lang,
            StartDate: moment(initData.startDate, "YYYY-MM-DD"),
            Target: target,
            LegendTarget: legendTarget,
            Mode: mode,
            EndDate: endDate,
            OnChange: (x, y) => { return onChange(x, y, axDatePicker) },
            OnlySelectDates: true,
            //CurrentDate: currentDate
        });

        axDatePicker.ActivationSubject.subscribe(x => checkDate(x, axDatePicker, dropDown, this));
    }

    // checkDateFrom
    checkDateFrom(cell: Cell, datePicker: AxDatePicker, dropDown: AxDropdown, that: any) {
        if (cell != null) {
            const formattedDate = cell.Date.format(that.datePattern);
            that.dateFrom = cell.Date;
            dropDown.setValue(formattedDate);

            // set startDate for datePickerTo
            datePicker.CurrentStartDate = that.dateFrom;
            that.openToDatePickerDesktop();
            that.openToDatePickerMobile();
        }

        $('.prod_selection__prod-save').removeAttr('disabled');
        that.closeFromDatePickerDesktop();
        that.closeFromDatePickerMobile();
        that.activateSearchButton();
    }

    // checkDateTo
    checkDateTo(cell: Cell, datePicker: AxDatePicker, dropDown: AxDropdown, that: any) {
        if (cell != null) {
            const formattedDate = cell.Date.format(that.datePattern);
            dropDown.setValue(formattedDate);
            that.dateTo = cell.Date;
        }

        $('.prod_selection__prod-save').removeAttr('disabled');

        that.closeToDatePickerDesktop();
        that.closeToDatePickerMobile();
        that.activateSearchButton();
    }

    // onChangeFromDate
    onChangeFromDate(startDate: moment.Moment, endDate: moment.Moment, axDatePicker: AxDatePicker): Promise<void> {
        return new Promise<void>((res, rej) => {
            const availableDates: moment.Moment[] = [];
            axDatePicker.Options.AvailableDates = availableDates;
            res();
        });
    }

    // onChangeToDate
    onChangeToDate(startDate: moment.Moment, endDate: moment.Moment, axDatePicker: AxDatePicker): Promise<void> {
        return new Promise<void>((res, rej) => {
            const availableDates: moment.Moment[] = [];
            axDatePicker.Options.AvailableDates = availableDates;
            res();
        });
    }

    // doSearBarSearch
    doSearBarSearch() {
        if (this.allDropDownsSet) {
            let currentUrl: string = window.location.href;

            if (currentUrl.includes("fromDate")) {
                currentUrl = currentUrl.substr(0, currentUrl.indexOf("?fromDate"));
            }

            const newUrl = `${currentUrl}?fromDate=${this.dateFrom.format('YYYY-MM-DD')}&toDate=${this.dateTo.format('YYYY-MM-DD')}&locationId=${0}`;

            window.location.href = newUrl;
        }
    }

    // openFromDatePicker
    openFromDatePickerDesktop() {
        if (!$('.compPack_searchBar_datePickerFromWrapper').hasClass('active')) {
            $('.compPack_searchBar_datePickerFromWrapper').addClass('active');
        }
    }

    // openToDatePicker
    protected openToDatePickerDesktop() {
        if (!$('.compPack_searchBar_datePickerToWrapper').hasClass('active')) {
            $('.compPack_searchBar_datePickerToWrapper').addClass('active');
        }
    }

    // closeFromDatePicker
    closeFromDatePickerDesktop() {
        if ($('.compPack_searchBar_datePickerFromWrapper').hasClass('active')) {
            $('.compPack_searchBar_datePickerFromWrapper').removeClass('active');
        }
    }

    // closeToDatePicker
    closeToDatePickerDesktop() {
        if ($('.compPack_searchBar_datePickerToWrapper').hasClass('active')) {
            $('.compPack_searchBar_datePickerToWrapper').removeClass('active');
        }
    }

    // openFromDatePicker
    openFromDatePickerMobile() {
        if (!$('.compPack_searchBar_datePickerMobileWrapper_from').hasClass('active')) {
            $('.compPack_searchBar_datePickerMobileWrapper_from').addClass('active');
        }

        if (!$('body').hasClass('overflow-hidden')) {
            $('body').addClass('overflow-hidden');
        }
    }

    // openToDatePicker
    openToDatePickerMobile() {
        if (!$('.compPack_searchBar_datePickerMobileWrapper_to').hasClass('active')) {
            $('.compPack_searchBar_datePickerMobileWrapper_to').addClass('active');
        }

        if (!$('body').hasClass('overflow-hidden')) {
            $('body').addClass('overflow-hidden');
        }
    }

    // closeFromDatePicker
    closeFromDatePickerMobile() {
        if ($('.compPack_searchBar_datePickerMobileWrapper_from').hasClass('active')) {
            $('.compPack_searchBar_datePickerMobileWrapper_from').removeClass('active');
        }

        if ($('body').hasClass('overflow-hidden')) {
            $('body').removeClass('overflow-hidden');
        }
    }

    // closeToDatePicker
    closeToDatePickerMobile() {
        if ($('.compPack_searchBar_datePickerMobileWrapper_to').hasClass('active')) {
            $('.compPack_searchBar_datePickerMobileWrapper_to').removeClass('active');
        }

        if ($('body').hasClass('overflow-hidden')) {
            $('body').removeClass('overflow-hidden');
        }
    }

    // closeOpenSelectors
    closeOpenSelectors(clickedElement: HTMLElement) {
        const locationSelect = $(".compPack-searchbar-location_select.compack_select");

        if (!clickedElement.classList.contains("axp__month-navigator")) {
            this.closeFromDatePickerDesktop();
            this.closeToDatePickerDesktop();

            if (locationSelect.hasClass('active')) {
                locationSelect.removeClass('active');
            }

            if ($('body').hasClass('overflow-hidden')) {
                $('body').removeClass('overflow-hidden');
            }
        }
    }

    // activateSearchButton
    activateSearchButton() {
        let fromDateString = "";
        let toDateString = "";

        if (this.dateFrom != undefined) {
            fromDateString = this.dateFrom.format('YYYY-MM-DD');
        }

        if (this.dateTo != undefined) {
            toDateString = this.dateTo.format('YYYY-MM-DD');
        }

        this.allDropDownsSet = fromDateString !== "" && toDateString !== "";

        $('#compPacks-teaser-input-search-button').prop('disabled', !(this.allDropDownsSet && this.dateTo >= this.dateFrom));
    }
}

export interface ICompPackSearchBarInitData {
    startOfWeek: number;
    lang: string;
    startDate: string;
    endDate?: string;
    postUrl: string;
    datePattern: string;
    datePatternYear: string;
    fromDate: string;
    toDate: string;
    locationId: number;
}